module.exports = __webpack_public_path__ + "img/plus.3f823d81.svg";